import { render, staticRenderFns } from "./addSeckill.vue?vue&type=template&id=988bb87a&scoped=true"
import script from "./addSeckill.vue?vue&type=script&lang=js"
export * from "./addSeckill.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addSeckill.vue?vue&type=style&index=1&id=988bb87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988bb87a",
  null
  
)

export default component.exports